'use client';

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import Cookies from "js-cookie";
import axiosRequest from "../api/axiosRequest";
import { PORTAL_PATH_PREFIXES } from "../lib/routeScopes";

const PageTracker = () => {
  const pathname = usePathname();

  // A normal page rendered — clear the chunk-reload guard so the next stale
  // deployment can auto-reload again. (See app/error.jsx.)
  useEffect(() => {
    sessionStorage.removeItem('chunk-reload');
  }, []);

  const getDeviceType = () => {
    const ua = navigator.userAgent;
    const width = window.innerWidth;
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) return "tablet";
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) return "mobile";
    if (width < 768) return "mobile";
    if (width < 1024) return "tablet";
    return "desktop";
  };

  useEffect(() => {
    const trackVisit = async () => {
      if (PORTAL_PATH_PREFIXES.some(path => pathname.startsWith(path))) return;
      try {
        let visitorId = Cookies.get("ct_visitor_id");
        let sessionId = Cookies.get("ct_session_id");
        const response = await axiosRequest("track-visit", "POST", {
          url: window.location.href,
          referrer: document.referrer,
          visitor_id: visitorId,
          session_id: sessionId,
          device_type: getDeviceType(),
        });
        const data = response.data;
        if (data?.visitor_id && !visitorId) Cookies.set("ct_visitor_id", data.visitor_id, { expires: 30 });
        if (data?.session_id && !sessionId) Cookies.set("ct_session_id", data.session_id, { expires: 30 / 1440 });
      } catch (error) {
        console.error("Traffic logging error", error);
      }
    };
    const timeout = setTimeout(() => trackVisit(), 1500);
    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
};

export default PageTracker;
